var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import GamesFilter from "./components/GamesFilter/GamesFilter";
import { connect } from "react-redux";
import { injectIntl, defineMessages } from "react-intl";
import { handleSelectFilterOption, getFilterProviders, getFilterTypes, cancelFiltering, clearOrderedGames, getAllGames, getLobbyGames, searchGames, clearGames, setIsTopGames, } from "../../actions/games/creators";
import Loader from "../Loader";
import MoreGames from "./components/GamesMore/MoreGames";
import GamesSearched from "./components/GamesSearched/GamesSearched";
import GamesPopular from "./components/GamesPopular/GamesPopular";
import GamesLobbyItems from "./components/GamesLobbyItems/GamesLobbyItems";
import GamesAllGames from "./components/GamesAllGames/GamesAllGames";
import GamesMenu from "./components/GamesMenu/GamesMenu";
import GamesPinned from "./components/GamesPinned/GamesPinned";
import GamesRecentVisited from "./components/GamesRecentVisited/GamesRecentVisited";
import { openAuthModal } from "../../actions/auth/creators/Login";
var messages = defineMessages({
    allGames: {
        id: "games.all_games",
        defaultMessage: "Все игры",
    },
    popular: {
        id: "games.popular",
        defaultMessage: "Популярные",
    },
    "-1": {
        id: "games.error_1",
        defaultMessage: "Системаная ошибка (Не удалось найти игрока в системе.)",
    },
    "-2": {
        id: "games.error_2",
        defaultMessage: "Игра временно недоступно, повторите попытку позже",
    },
    "-3": {
        id: "games.error_2",
        defaultMessage: "Игра временно недоступно, повторите попытку позже",
    },
    "-5": {
        id: "games.error_5",
        defaultMessage: "Системная ошибка (Данная игра не поддерживается на текущей платформе.)",
    },
});
var isJivoClosed = false;
var PAGE_TYPE = {
    moreGames: "moreGames",
    searchedGames: "searchedGames",
    lobbyGames: "lobbyGames",
    popularGames: "popularGames",
    allGames: "allGames",
    pinnedGames: "pinnedGames",
    recentVisitedGames: "recentVisitedGames",
};
var GAMES_PAGE_LIMIT = typeof window !== "undefined" && window.innerWidth < 768 ? 12 : 24;
var Games = /** @class */ (function (_super) {
    __extends(Games, _super);
    function Games() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            inputValue: "",
            currentPageType: PAGE_TYPE.lobbyGames,
            moreGameDetails: {
                gameType: null,
                name: null,
            },
        };
        _this.openPreloadedProvider = function (provider) {
            var _a = _this.props, user = _a.user, limit = _a.limit;
            _this.props.cancelFilteringAction();
            _this.props.handleSelectFilterOptionAction(provider, "selectedProviders");
            _this.props.searchGamesAction({
                providers: [provider.Id],
                types: "",
                gamblerId: user.gamblerId,
                limit: limit,
                offset: 0,
            });
            _this.showSpecificGames(PAGE_TYPE.searchedGames);
        };
        _this.openRouteType = function (typeId) {
            var _a = _this.props, types = _a.types, user = _a.user;
            var found = types && types.find(function (item) { return String(item.Id) === String(typeId); });
            var option = { Id: Number(typeId), Name: found ? found.Name : "" };
            _this.setState({ inputValue: "" });
            _this.props.cancelFilteringAction();
            _this.props.handleSelectFilterOptionAction(option, "selectedTypes");
            _this.props.clearGamesAction();
            _this.props.searchGamesAction({
                types: [option.Id],
                providers: "",
                gamblerId: user.gamblerId,
                limit: GAMES_PAGE_LIMIT,
                offset: 0,
            });
            _this.showSpecificGames(PAGE_TYPE.searchedGames);
        };
        _this.openRouteProvider = function (providerRef) {
            var _a = _this.props, providers = _a.providers, user = _a.user;
            var found = providers && providers.find(function (item) { return item.Name === providerRef; });
            _this.setState({ inputValue: "" });
            _this.props.cancelFilteringAction();
            _this.showSpecificGames(PAGE_TYPE.searchedGames);
            if (!found)
                return;
            _this.props.handleSelectFilterOptionAction({ Id: found.Id, Name: found.Name }, "selectedProviders");
            _this.props.clearGamesAction();
            _this.props.searchGamesAction({
                providers: [found.Id],
                types: "",
                gamblerId: user.gamblerId,
                limit: GAMES_PAGE_LIMIT,
                offset: 0,
            });
        };
        _this.backToGamesRoute = function () {
            _this.props.setIsTopGamesAction(false);
            _this.props.cancelFilteringAction();
            _this.clearSearchField();
            _this.props.history.push("/games");
        };
        _this.formatFilterOptions = function (option) {
            return Array.from(option)
                .map(function (item) { return item[0]; })
                .join(",");
        };
        _this.onHandleInputValueChange = function (e) {
            _this.setState({
                inputValue: e.target.value,
            });
        };
        _this.getMoreGames = function (name, gameType) {
            _this.setState({
                currentPageType: PAGE_TYPE.moreGames,
                moreGameDetails: {
                    gameType: gameType,
                    name: name,
                },
            });
        };
        _this.goToLobbyGames = function () {
            _this.props.setIsTopGamesAction(false);
            _this.setState({
                currentPageType: PAGE_TYPE.lobbyGames,
                moreGameDetails: {
                    gameType: null,
                    name: null,
                },
            });
        };
        _this.backGamesPage = function () {
            _this.goToLobbyGames();
        };
        _this.showSpecificGames = function (gamesPage) {
            return _this.setState({ currentPageType: gamesPage });
        };
        _this.getToPinnedGames = function (e) {
            var gamblerId = _this.props.user.gamblerId;
            if (gamblerId) {
                _this.props.clearGamesAction();
                _this.showSpecificGames(PAGE_TYPE.pinnedGames);
            }
            else {
                _this.props.openAuthModal();
            }
        };
        _this.getToRecentArrivedGames = function (e) {
            var gamblerId = _this.props.user.gamblerId;
            if (gamblerId) {
                _this.props.clearGamesAction();
                _this.showSpecificGames(PAGE_TYPE.recentVisitedGames);
            }
            else {
                _this.props.openAuthModal();
            }
        };
        _this.errorRenderer = function (error) {
            if (error instanceof Error) {
                return _jsx("h3", __assign({ style: { textAlign: "center" } }, { children: error.message }));
            }
        };
        _this.pageRenderer = function (pageType) {
            var _a = _this.props, gameTypes = _a.gameTypes, topGames = _a.topGames, allGames = _a.allGames;
            switch (pageType) {
                case PAGE_TYPE.popularGames:
                    return _jsx(GamesPopular, { backGamesPage: _this.backGamesPage });
                case PAGE_TYPE.allGames:
                    return _jsx(GamesAllGames, { backGamesPage: _this.backGamesPage });
                case PAGE_TYPE.pinnedGames:
                    return _jsx(GamesPinned, {});
                case PAGE_TYPE.recentVisitedGames:
                    return _jsx(GamesRecentVisited, {});
                case PAGE_TYPE.searchedGames:
                    return (_jsx(GamesSearched, { inputValue: _this.state.inputValue, onBack: _this.backToGamesRoute }));
                case PAGE_TYPE.moreGames:
                    return _jsx(MoreGames, { gameDetails: _this.state.moreGameDetails, backGamesPage: _this.backGamesPage });
                case PAGE_TYPE.lobbyGames:
                    return (_jsxs(React.Fragment, { children: [gameTypes &&
                                gameTypes.map(function (game) {
                                    return (_jsx("div", { children: _jsx(GamesLobbyItems, { games: game.Games, getMore: function () {
                                                return _this.props.history.push("/games/types/".concat(game.Id));
                                            }, title: game.Name }) }, game.Id));
                                }), _jsx(GamesLobbyItems, { games: allGames.Items && allGames.Items.slice(0, 12), getMore: function () { return _this.showSpecificGames(PAGE_TYPE.allGames); }, title: _this.props.intl.formatMessage(messages.allGames) })] }));
                default:
                    return null;
            }
        };
        _this.clearSearchField = function () {
            _this.setState({
                inputValue: "",
            });
        };
        return _this;
    }
    Games.prototype.componentDidMount = function () {
        var _a = this.props, gameTypes = _a.gameTypes, topGames = _a.topGames, user = _a.user, allGames = _a.allGames, location = _a.location;
        var gameQuery = this.props.match.params.gameQuery;
        if (gameQuery && gameQuery.trim()) {
            this.setState({ inputValue: gameQuery });
            this.props.clearGamesAction();
            this.props.cancelFilteringAction();
            this.props.setIsTopGamesAction(false);
            this.props.searchGamesAction({
                name: gameQuery.trim(),
                types: "",
                providers: "",
                gamblerId: user.gamblerId,
                isTop: null,
                limit: GAMES_PAGE_LIMIT,
                offset: 0,
            });
            this.showSpecificGames(PAGE_TYPE.searchedGames);
        }
        else if (this.props.routeType) {
            this.openRouteType(this.props.routeType);
        }
        else if (this.props.routeProvider) {
            this.openRouteProvider(this.props.routeProvider);
        }
        else if (location.state && location.state.provider) {
            this.openPreloadedProvider({
                Id: location.state.provider,
                Name: "Provider",
            });
        }
        else {
            if (!topGames || !gameTypes) {
                this.props.getLobbyGamesAction(user.gamblerId, this.props.langId);
            }
            if (allGames.Items.length === 0) {
                this.props.getMoreAllGamesAction({ gamblerId: user.gamblerId });
            }
        }
        // setTimeout(() => {
        if (window.jivo_destroy) {
            window.jivo_destroy();
        }
        if (!this.props.providers)
            this.props.getFilterProvidersAction();
        if (!this.props.types)
            this.props.getFilterTypesAction();
        // }, 1000);
    };
    Games.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _this = this;
        if (prevProps.langId !== this.props.langId) {
            this.props.getLobbyGamesAction(this.props.user.gamblerId, this.props.langId);
        }
        // После clearGames() в GamesList при уходе с MoreGames/поиска Items пуст —
        // при возврате в лобби перезагружаем превью «Все игры».
        if (prevState.currentPageType !== PAGE_TYPE.lobbyGames &&
            this.state.currentPageType === PAGE_TYPE.lobbyGames) {
            this.props.getMoreAllGamesAction({ gamblerId: this.props.user.gamblerId });
        }
        if (this.props.routeProvider &&
            this.props.providers &&
            prevProps.providers !== this.props.providers) {
            var found = this.props.providers.find(function (item) { return item.Name === _this.props.routeProvider; });
            if (found && !this.props.selectedProviders.has(found.Id)) {
                this.openRouteProvider(this.props.routeProvider);
            }
        }
        var intent = this.getRouteIntent(this.props);
        var prevIntent = this.getRouteIntent(prevProps);
        var intentValue = intent.id || intent.q || null;
        var prevIntentValue = prevIntent.id || prevIntent.q || null;
        if (intent.kind === prevIntent.kind && intentValue === prevIntentValue) {
            return;
        }
        if (intent.kind === "type") {
            this.openRouteType(intent.id);
        }
        else if (intent.kind === "provider") {
            this.openRouteProvider(intent.id);
        }
        else if (intent.kind === "search") {
            this.props.clearOrderedGamesAction();
            this.props.clearGamesAction();
            this.props.setIsTopGamesAction(false);
            this.props.searchGamesAction({
                name: intent.q,
                types: "",
                providers: "",
                gamblerId: this.props.user.gamblerId,
                isTop: null,
                limit: GAMES_PAGE_LIMIT,
                offset: 0,
            });
            this.setState({ inputValue: intent.q });
            this.showSpecificGames(PAGE_TYPE.searchedGames);
        }
        else {
            var isMulti = this.props.selectedTypes.size > 1 || this.props.selectedProviders.size > 1;
            this.props.setIsTopGamesAction(false);
            this.setState({ inputValue: "" });
            if (isMulti) {
                this.showSpecificGames(PAGE_TYPE.searchedGames);
            }
            else {
                this.props.clearOrderedGamesAction();
                if (!this.props.topGames || !this.props.gameTypes) {
                    this.props.getLobbyGamesAction(this.props.user.gamblerId, this.props.langId);
                }
                this.showSpecificGames(PAGE_TYPE.lobbyGames);
            }
        }
    };
    Games.prototype.getRouteIntent = function (props) {
        if (props.routeType)
            return { kind: "type", id: String(props.routeType) };
        if (props.routeProvider) {
            return { kind: "provider", id: String(props.routeProvider) };
        }
        var gameQuery = props.match && props.match.params && props.match.params.gameQuery;
        if (gameQuery && gameQuery.trim()) {
            return { kind: "search", q: gameQuery.trim() };
        }
        return { kind: "lobby" };
    };
    Games.prototype.componentWillUnmount = function () {
        this.props.cancelFilteringAction();
        if (typeof window !== 'undefined') {
            window.removeEventListener("scroll", this.handleScroll);
        }
        if (typeof window.jivo_init === 'function') {
            window.jivo_init();
        }
    };
    Games.prototype.render = function () {
        var _this = this;
        var _a = this.props, isLoading = _a.isLoading, isLoadingAllGames = _a.isLoadingAllGames, error = _a.error;
        if (window.jivo_destroy && !isJivoClosed) {
            window.jivo_destroy();
            isJivoClosed = true;
        }
        return (_jsxs("div", { children: [_jsx(GamesFilter, { goToLobbyGames: this.goToLobbyGames, goToSearchedGames: function () {
                        return _this.showSpecificGames(PAGE_TYPE.searchedGames);
                    }, clearSearchField: this.clearSearchField, onHandleInputValueChange: this.onHandleInputValueChange, inputValue: this.state.inputValue, isInLobbyGames: this.state.currentPageType === PAGE_TYPE.lobbyGames }), (isLoading || isLoadingAllGames) && _jsx(Loader, {}), _jsxs("div", { children: [this.pageRenderer(this.state.currentPageType), this.errorRenderer(error), _jsx(GamesMenu, { cancelFiltering: this.props.cancelFilteringAction, clearSearchField: this.clearSearchField, getToPinnedGames: this.getToPinnedGames, goToLobbyGames: this.goToLobbyGames, getToRecentArrivedGames: this.getToRecentArrivedGames })] })] }));
    };
    return Games;
}(Component));
var mapStateToProps = function (state) {
    var _a = state.games.lobbyGames, topGames = _a.topGames, gameTypes = _a.gameTypes, error = _a.error, isLoading = _a.isLoading;
    var _b = state.games.games, allGames = _b.data, isLoadingAllGames = _b.isLoading;
    var _c = state.games.gamesFilter, selectedTypes = _c.selectedTypes, selectedProviders = _c.selectedProviders, types = _c.types, providers = _c.providers;
    var errorOpenGame = state.games.openGame.error;
    return {
        errorOpenGame: errorOpenGame,
        allGames: allGames,
        isLoadingAllGames: isLoadingAllGames,
        gameTypes: gameTypes,
        topGames: topGames,
        error: error,
        isLoading: isLoading,
        user: state.auth.user,
        langId: state.application.get("languageId"),
        darkTheme: state.application.get("darkTheme"),
        selectedProviders: selectedProviders,
        selectedTypes: selectedTypes,
        types: types,
        providers: providers,
    };
};
var mapDispatchToProps = {
    handleSelectFilterOptionAction: handleSelectFilterOption,
    getFilterProvidersAction: getFilterProviders,
    getFilterTypesAction: getFilterTypes,
    getLobbyGamesAction: getLobbyGames,
    cancelFilteringAction: cancelFiltering,
    clearOrderedGamesAction: clearOrderedGames,
    searchGamesAction: searchGames,
    getMoreAllGamesAction: getAllGames,
    clearGamesAction: clearGames,
    openAuthModal: openAuthModal,
    setIsTopGamesAction: setIsTopGames,
};
export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Games)));



// WEBPACK FOOTER //
// ./src/components/games/Games.jsx